import SvgIcon from '@/components/SvgIcon'

// 这里是 ./svg是路径
const webpackContext = require.context("./svg", true, /\.svg$/);
const requireAll = (requireContext) => {
  // requireContext.keys()   匹配的 文件路径数组
  return requireContext.keys().map(requireContext);
};
// 得到一个完整解析的module数组
requireAll(webpackContext);

// 创建全局组件
export default (app) => {
  app.component('svg-icon', SvgIcon)
}